module.exports = __webpack_public_path__ + "img/tofusalat-cutted.db344919.png";